import { apiSlice } from "../../app/apiSlice";
import { NodeDefinitions} from "../editor/editorSlice";

export const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder => (
        {
            getCatalog: builder.query<NodeDefinitions, {runtimeType?:string, kind?:string} >({
                query: (data) => ({
                    url: `/libraries?runtimeMode=${data.runtimeType}${data.kind ? `&kind=${data.kind}` : ''}`
                }),
            }),
            postNewNode: builder.mutation<any, any>({
                query: (node) => ({url: `/node/addNoder`, method: 'post', body: node}),
            }),

            importFunction: builder.mutation<any, any>({
                query: (node) => ({ url: `/libraries/node`, method: 'post', body: node }),
            }),

            yamlFunction: builder.query<any, { id: string }>({
                query: (data) => ({ url: `/libraries/yaml?id=${encodeURIComponent(data.id)}` }),
            }),

            updateNode: builder.mutation<any, any>({
                query: (node) => ({url: `/libraries/node`, method: 'put', body: node}),
            }),

            deleteFunction: builder.mutation<any, { id: string }>({
                query: (node) => ({ url: `/libraries/node`, method: 'delete', body: node.id }),
            }),
        }
    )),
    overrideExisting: false
})


export const {
    useLazyGetCatalogQuery,
    usePostNewNodeMutation,
    useImportFunctionMutation,
    useUpdateNodeMutation,
    useDeleteFunctionMutation,
    useLazyYamlFunctionQuery
} = extendedApi